import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [googleOnly, setGoogleOnly] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setGoogleOnly(!!data.google_only);
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFBFA] p-6">
      <div className="w-full max-w-sm mo-fade-up" data-testid="forgot-password-page">
        <div className="mb-8"><Link to="/"><Logo /></Link></div>
        {sent ? (
          <div className="rounded-2xl mo-card p-6 text-center" data-testid="forgot-password-sent">
            <div className="mx-auto h-12 w-12 rounded-full bg-[#5aa469]/12 flex items-center justify-center mb-4"><MailCheck className="h-6 w-6 text-[#4a8a56]" /></div>
            <h1 className="font-display font-bold text-2xl mb-2">Controlla la tua email</h1>
            {googleOnly ? (
              <p className="text-gray-600 text-sm">Questo account accede con <strong>Google</strong>: non ha una password da reimpostare. Torna al login e usa "Continua con Google".</p>
            ) : (
              <p className="text-gray-600 text-sm">Se <strong>{email}</strong> è registrata, riceverai entro pochi minuti un link per scegliere una nuova password. Il link vale 1 ora.</p>
            )}
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#5aa469] font-medium hover:underline mt-6" data-testid="back-to-login"><ArrowLeft className="h-4 w-4" /> Torna al login</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display font-bold text-4xl mb-2">Password dimenticata?</h1>
            <p className="text-gray-500 mb-8">Inserisci l'email del tuo account: ti invieremo un link per reimpostarla.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11 rounded-lg focus:border-[#5aa469]" placeholder="tua@email.it" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-full bg-[#5aa469] hover:bg-[#4a8a56] text-white font-semibold active:scale-95 transition-transform" data-testid="forgot-submit">
                {loading ? "Invio…" : "Invia link di recupero"}
              </Button>
            </form>
            <p className="text-sm text-gray-500 mt-6 text-center">
              <Link to="/login" className="inline-flex items-center gap-1 text-[#5aa469] font-medium hover:underline" data-testid="back-to-login"><ArrowLeft className="h-4 w-4" /> Torna al login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
